import { trans } from "@mongez/localization";
import { cn } from "core/shared";
import { requestWeddingCakesStepsAtom } from "~/modules/home/atoms";
import { RequestWeddingAccountInformation } from "./RequestWeddingAccountInformation";
import { RequestWeddingCakeInformation } from "./RequestWeddingCakeInformation";

export function RequestWeddingCakesSteps() {
  const currentStep = requestWeddingCakesStepsAtom.useValue();

  return (
    <>
      <div className="flex flex-col gap-3">
        <p className="font-avenir text-xs font-semibold tracking-[0.08rem] lg:text-sm">
          {trans("stepNumber", {
            currentStep,
            totalSteps: 2,
          })}
        </p>
        <div className="grid grid-cols-2 items-center gap-3.5">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={index}
              className={cn(
                "h-1.5 rounded-[1.125rem] bg-[#E4B5BC]",
                currentStep < index + 1 && "bg-[#F5E6E8]",
              )}
            />
          ))}
        </div>
        <h3 className="font-playfair text-night text-2xl font-bold">
          {currentStep === 1
            ? trans("accountInformation")
            : trans("cakeInformation")}
        </h3>
      </div>
      {currentStep === 1 && <RequestWeddingAccountInformation />}
      {currentStep === 2 && <RequestWeddingCakeInformation />}
    </>
  );
}
